

export default function AboutMe() {
    return(
        <section id='AboutMe' className="about-section">
            <div className="about-section-img">
                <img src="./img/angel-girasoles.png" alt="aboutme"/>
            </div>
            <div className="hero-section-content-box about-section-box">
                <div>
                    <p className="sub-title">About</p>
                    <h1 className="skill-section-heading">About Me</h1>
                </div>
                <p className="hero-section-text">
                    I am a passionate and dedicated developer, ready to take new challenges and opportunities 
                    to grow professionally. I strive to apply what I learn at work to enhance my day-to-day life. 
                    I like to think of myself as an explorer, with many interests and hobbies.
                </p>
                <p className="hero-section-text">
                    Beyond coding 🧑🏽‍💻, I enjoy creating music 🎶, exploring the underwater 
                    world through scuba diving 🤿, traveling the globe 🌎, and immersing myself 
                    in gaming adventures 🎮.
                </p>
            </div>
        </section>
    )
}